import React from 'react';
import { ArrowDown } from 'lucide-react';
import './Hero.css';
import cricketBg from '../assets/cricket-final-bg.png';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background" style={{backgroundImage: `url(${cricketBg})`}}></div>
      <div className="hero-overlay"></div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-logo-container animate-fadeIn">
            <img src="/assets/otp-logo.png" alt="OTP Sports" className="hero-logo" />
          </div>
          
          <div className="verticals-line animate-fadeIn delay-200">
            <span className="vertical-item">Talent</span>
            <span className="vertical-divider">|</span>
            <span className="vertical-item">Content</span>
            <span className="vertical-divider">|</span>
            <span className="vertical-item">IP</span>
            <span className="vertical-divider">|</span>
            <span className="vertical-item">Consulting</span>
          </div>
          
          <button onClick={scrollToContact} className="scroll-cta animate-fadeIn delay-300">
            Get in Touch
            <ArrowDown size={20} className="scroll-icon" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;